import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import Loadingmini from '../components/loadingmini';
import { Flex, View, Text, Button, Heading} from '@aws-amplify/ui-react';

export default function Vehicleregistration({vehicle, fleetCode}) {
  const [is_loading, updateIsLoading] = React.useState(false);
  const [registration_url, updateRegistrationUrl] = React.useState(false);
  const [myerror, updateMyerror] = React.useState(false);
  const [mysuccess, updateMySuccess] = React.useState(false);
  const [showOptions, updateShowOptions] = React.useState(false);
  const [showUploadRegistration, updateShowUploadRegistration] = React.useState(false);
	const [selectedFile, setSelectedFile] = useState();
  const [presigned_url, updatePresignedUrl] = React.useState("");
  const [new_document_name, updateNewDocumentName] = React.useState("");
	const [isSelected, setIsSelected] = useState(false);

  async function submitRegistration() {
    updateIsLoading(true);
    if(!isSelected)
    {
      updateMyerror("Please select a file before submitting.")
      updateIsLoading(false);
      return;
    }
    let session = await Auth.currentSession() 
    fetch(presigned_url, {
        method:'PUT',
        body:selectedFile,
        headers: {
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Origin': '*'
        }
    }).then((res) => {
        console.log('res:'+JSON.stringify(res))
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            back_end: process.env.REACT_APP_BACKEND, 
            jwt:jwt, 
            api_endpoint: "api3:vehicles:documents",
            request_type: "GET",
            kind: "registration",
            document_name:new_document_name,
            vehicle_id: vehicle['resp'][0]['car_id'],
            fleet_code:fleetCode
        }};
        //console.log('myInit:'+JSON.stringify(myInit))
        try {
            API.get('adminWebTools','/ago',myInit).then((res3) => {
                console.log(JSON.stringify(res3))
                updateMySuccess(true)
            });
        } catch (e) {
            var statusString = "Error uploading file: " + e;
            updateMyerror(statusString);
        }
    })
    updateIsLoading(false);
  }

	const updateFile = (event) => {
		setSelectedFile(event.target.files[0]);
		setIsSelected(true);
	};

  async function getPresignedUrl() {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint:"api3:vehicles:documents",
        request_type:"GET",
        kind:"registration",
        vehicle_id: vehicle['resp'][0]['car_id'],
        fleet_code:fleetCode
    }};
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        updatePresignedUrl(res["presigned_url_upload"]);
        updateNewDocumentName(res["new_document_name"]);
    }
    catch (e) {
        const res = {status:"Error: " + JSON.stringify(e)}
        updateMyerror(res)
    }
    updateIsLoading(false)
  }

  async function getImageUrl() {
    updateIsLoading(true)
    console.log('generating registration for car ' + vehicle['resp'][0]['car_id'] + "...");
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{ 
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint:"api3:vehicles:registration",
        request_type:"GET",
        vehicle_id: vehicle['resp'][0]['car_id'],
        fleet:fleetCode,
        registration:true,
    }};
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        //console.log(JSON.stringify(res))
        if('vehicle_info' in res === false)
        {
          updateMyerror("no vehicle_info in res")
          updateIsLoading(false)
          return
        }
        if('reg_url' in res['vehicle_info'] === false)
        {
          updateMyerror("no reg_url in vehicle_info")
          updateIsLoading(false)
          return
        }
        updateRegistrationUrl(res['vehicle_info']['reg_url'])
        updateShowUploadRegistration(false);
        updateMyerror(false)
        updateMySuccess(false)
        updateIsLoading(false)
        return
    }
    catch (e) {
        console.log(JSON.stringify(e))
        updateMyerror(JSON.stringify(e));
        updateIsLoading(false)
        return
    }
  }


  useEffect(() => {
    getPresignedUrl();
  },[])

  return (
    is_loading ? <Loadingmini /> : 
      <Flex
        direction="column"
      >
        <View style={{width:"100%"}}>
          <Flex direction="column" gap="1rem" >
            <Flex direction="column">
                { myerror ? <View>
                          <Heading level={4}>Whoops!</Heading>
                          <Text>We ran into an error processing your request:</Text>
                          <Text>{typeof myerror === 'string' ? myerror : JSON.stringify(myerror)}</Text>
                        <Button onClick={() => getImageUrl()}>TRY AGAIN</Button>
                    </View>
                  :
                  mysuccess ? <View>
                          <Heading level={4}>Success!</Heading>
                          <Text>Your registration has been uploaded.</Text>
                        <Button onClick={() => getImageUrl()}>VIEW REGISTRATION</Button>
                    </View>
                  :
                  registration_url ? 
                    <View>
                      <Text><a href={registration_url} target='_blank'>CLICK TO DOWNLOAD REGISTRATION</a></Text>
                      <br />
                      <Button onClick={() => updateRegistrationUrl(false)}>CANCEL</Button>
                    </View>
                  : showUploadRegistration ?
                    <View>
                      <Heading level={2}>Upload Registration</Heading>
                      <input type="file" name="file" onChange={updateFile} accept=".jpg, .png, .jpeg" />
                      {isSelected ? (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}>
                          <Text>Filename: {selectedFile.name}</Text>
                          <Text>Filetype: {selectedFile.type}</Text>
                          <Text>Size in bytes: {selectedFile.size}</Text>
                          <Text>
                            lastModifiedDate:{' '}
                            {selectedFile.lastModifiedDate.toLocaleDateString()}
                          </Text>
                        </View>
                      ) : (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}><Text>Select a file to show details</Text></View>
                      )}
                      <br />
                      <Button onClick={() => submitRegistration()}>SUBMIT</Button>
                      <br />
                      <br />
                      <Button onClick={() => updateShowUploadRegistration(false)}>CANCEL</Button>
                    </View>
                  : showOptions ?
                    <View>
                      <Button onClick={() => getImageUrl()}>VIEW REGISTRATION</Button>
                      <br/>
                      <br/>
                      <Button onClick={() => updateShowUploadRegistration(true)}>UPLOAD REGISTRATION</Button>
                      <br/>
                      <br/>
                      <Button onClick={() => updateShowOptions(false)}>MINIMIZE REGISTRATION</Button>
                    </View>
                  : <Button onClick={() => updateShowOptions(true)}>REGISTRATION</Button>
                }
            </Flex>
          </Flex>
        </View>
      </Flex>
  );
}